import { createContext, useCallback, useMemo, useState } from "react";
import type { ReactNode } from "react";

interface Ctx { term: string; setTerm: (v: string) => void }

export const PageSearchContext = createContext<Ctx | null>(null);

export function PageSearchProvider({ children }: { children: ReactNode }) {
  const [term, setTermState] = useState("");
  const setTerm = useCallback((v: string) => setTermState(v), []);
  const value = useMemo(() => ({ term, setTerm }), [term, setTerm]);
  return <PageSearchContext.Provider value={value}>{children}</PageSearchContext.Provider>;
}
